import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus, faTrain, faPersonWalking, faMapMarkedAlt, faTicket, faMapMarkerAlt, faFlagCheckered, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import LocationService from '../services/LocationService';
import './RouteDetailsRouteLeg.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import KtmbApiService from '../ktmb/KtmbApiService';
import KtmbTimetableResult from '../ktmb/KtmbTimetableResult';
import { useState } from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const RouteDetailsRouteLeg = ({index, step, getTransitIcon, selectedRoute, todayDate }) => {
  const [showTimetableModal, setShowTimetableModal] = useState(false);
  const [timetableData, setTimetableData] = useState(null);
  const [timetableError, setTimetableError] = useState(null);
  const [timetableLoading, setTimetableLoading] = useState(false);
  const [tabDate, setTabDate] = useState(todayDate ? new Date(todayDate) : new Date());
  const [date, setDate] = useState(todayDate || new Date().toISOString().split('T')[0]);

  const getBuyTicketUrl = (shortName) => {
    if (shortName?.startsWith('KTM Komuter')) {
      return process.env.REACT_APP_KOMUTER_URL || 'mpay.apps.kits.superapp.uat.scheme://ai_journey?goWhere="komuter"';
    } else if (shortName === 'ETS') {
      return process.env.REACT_APP_ETS_URL || 'mpay.apps.kits.superapp.uat.scheme://ai_journey?goWhere="ets_intercity"';
    } else if (shortName === 'KTM Shuttle Tebrau') {
      return process.env.REACT_APP_SHUTTLE_URL || 'mpay.apps.kits.superapp.uat.scheme://ai_journey?goWhere="shuttle"';
    }
    return null;
  };

  const fetchTimetableForDate = async (dateObj) => {
    setTimetableLoading(true);
    setTimetableError(null);
    try {
      const ktmbApiService = new KtmbApiService();
      const fromStationId = step.startLocation?.ktmbStationInfo?.stationId;
      const toStationId = step.endLocation?.ktmbStationInfo?.stationId;
      const pax = selectedRoute?.noOfPassenger || 1;
      const departTime = dateObj.toISOString().split('T')[0];
      if (fromStationId && toStationId) {
        const timetable = await ktmbApiService.getTimeTable(fromStationId, toStationId, departTime, pax);
        setTimetableData({
          ...timetable,
          fromStation: step.startLocation?.ktmbStationInfo?.stationName || step.startLocation?.name,
          toStation: step.endLocation?.ktmbStationInfo?.stationName || step.endLocation?.name,
          departDate: departTime
        });
      } else {
        setTimetableError('Station information missing.');
      }
    } catch (err) {
      setTimetableError(err.error);
    } finally {
      setTimetableLoading(false);
    }
  };

  const handleBuyTicket = async (e, url) => {
    e.preventDefault();
    setTabDate(todayDate ? new Date(todayDate) : new Date());
    setDate(todayDate || new Date().toISOString().split('T')[0]);
    setTimetableLoading(true);
    setTimetableError(null);
    try {
      const ktmbApiService = new KtmbApiService();
      const fromStationId = step.startLocation?.ktmbStationInfo?.stationId;
      const toStationId = step.endLocation?.ktmbStationInfo?.stationId;
      const pax = selectedRoute?.noOfPassenger || 1;
      const departTime = todayDate;

      if (fromStationId && toStationId) {
        const timetable = await ktmbApiService.getTimeTable(fromStationId, toStationId, departTime, pax);
        setTimetableData({
          ...timetable,
          fromStation: step.startLocation?.ktmbStationInfo?.stationName || step.startLocation?.name,
          toStation: step.endLocation?.ktmbStationInfo?.stationName || step.endLocation?.name,
          departDate: departTime
        });
        setShowTimetableModal(true);
      } else {
        setTimetableError('Station information missing.');
        setShowTimetableModal(true);
      }
    } catch (err) {
      // console.log("err", JSON.stringify(err));
      // console.log("13jl12j312lj3123", err);
      setTimetableError(err);
      setShowTimetableModal(true);
    } finally {
      setTimetableLoading(false);
    }
    // window.location.href = url; // Comment out for now to avoid redirecting away
    // setTimeout(() => {
    //   if (window.location.href === window.location.href) {
    //     window.open('https://www.ktmb.com.my/', '_blank');
    //   }
    // }, 1000);
  };

  const buyTicketUrl = getBuyTicketUrl(step.transitLine?.shortName);

  return (
    <div key={index} className="route-leg">
      <div className="departure-time">
        {step.departureTime}
      </div>

      <div className="transport-icon-container">
        <div className="transport-icon">
          {step.travelMode === 'WALK' && <FontAwesomeIcon icon={faPersonWalking} />}
          {step.travelMode === 'TRANSIT' &&
            <img 
              src={step.transitLine.vehicle.iconUrl} 
              alt={step.transitLine.vehicle.name}
              className="vehicle-icon"
            />
          }
        </div>
        <div className={`transport-line ${step.travelMode === 'WALK' ? 'walk-line' : 'transit-line'}`}
             style={{ borderLeftColor: step.travelMode === 'TRANSIT' ? step.transitLine?.color : undefined }}></div>
      </div>

      <div className="route-details">
        <div className="duration-distance">
          {step.duration} • {step.distance}
        </div>
        {/* <div>{JSON.stringify(step)}</div> */}
        {/* <div style={{ fontSize: '1.05rem', fontWeight: 600, color: '#1E1E1E' }}>
          {LocationService.getLocationName(step.startLocation.latitude, step.startLocation.longitude)} → {LocationService.getLocationName(step.endLocation.latitude, step.endLocation.longitude)}
        </div> */}

        {step.travelMode === 'WALK' && (
          <div className="walk-instruction">
            {step.instruction}
          </div>
        )}

        {step.travelMode === 'TRANSIT' && (
          <>
            <div className="transit-info">
              <span className="transit-line-badge" style={{ backgroundColor: step.transitLine?.color }}>
                {step.transitLine?.shortName ? step.transitLine.shortName : step.transitLine?.name || ''}
              </span>
            </div>
            <div className="station-labels">
              <div className="station-label">
                <FontAwesomeIcon icon={faLocationDot} style={{ marginRight: 4 }} /> {step.startLocation?.ktmbStationInfo?.stationName || step.startLocation?.name}
              </div>
              <div className="station-label">
                <FontAwesomeIcon icon={faFlagCheckered} style={{ marginRight: 4 }} /> {step.endLocation?.ktmbStationInfo?.stationName || step.endLocation?.name}
              </div>
            </div>
            <div>
              <span className="transit-instruction">
                {step.instruction}
              </span>
            </div>
            {step.transitLine.ktmb && (
              <a
                href={buyTicketUrl}
                className="buy-ticket-button"
                onClick={(e) => handleBuyTicket(e, buyTicketUrl)}
                style={{ pointerEvents: timetableLoading ? 'none' : 'auto', opacity: timetableLoading ? 0.7 : 1 }}
              >
                
                {timetableLoading ? (
                  <FontAwesomeIcon icon={faSpinner} spin style={{ marginLeft: 6 }} />
                ) : (
                  <FontAwesomeIcon icon={faTicket} className="buy-ticket-icon" />
                  
                )}
                KTMB Ticket / Timetable
              </a>
            )}
          </>
        )}
      </div>
      {showTimetableModal && (
        <div className="ktmb-timetable-modal-overlay">
          <div className="ktmb-timetable-modal-content">
            <button
              onClick={() => setShowTimetableModal(false)}
              className="ktmb-timetable-modal-close"
              aria-label="Close timetable"
            >
              ✕
            </button>
            <KtmbTimetableResult
              timetableData={timetableData || {}}
              errorMsg={timetableError}
              searchLoading={timetableLoading}
              onBack={() => setShowTimetableModal(false)}
              tabDate={tabDate}
              setTabDate={(newDate) => {
                setTabDate(newDate);
                setDate(newDate.toISOString().split('T')[0]);
              }}
              setDate={(newDateStr) => {
                setDate(newDateStr);
                setTabDate(new Date(newDateStr));
              }}
              fetchTimetableForDate={fetchTimetableForDate}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RouteDetailsRouteLeg; 